import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const pastOrderApis = createApi({
  reducerPath: 'pastOrderApis',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
    prepareHeaders: (headers, { getState }) => {
      // Extract token from state
      const token = getState()?.posData?.token;
      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPastOrders: builder.query({
      query: ({page, limit, order_type, search, start_date, end_date}) => ({
        url: '/order/past',
        method: 'GET',
        params: {page, perPage: limit, order_type, search, start_date, end_date}
      }),
      providesTags: ['orders'],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
  }),
});

export const { useGetPastOrdersQuery } = pastOrderApis;
